import { useContext, useCallback } from "react";
import { useWindowSize } from "../useWindowSize/useWindowSize.js";
import { FocusModalContext } from "./FocusModalContext.js";
import "../../sass/sass.js";
import "../useWindowSize/WindowSizeContext.js";
import "react/jsx-runtime";
import "../../utils/noOp.js";
import "../../isObject-ec23ace2.js";
import "../../isSymbol-c6f5cd95.js";
function useFocusModal(elementId) {
  const { registeredModals, setRegisteredModals, currentModal, targetZIndex } = useContext(FocusModalContext), { windowIsMobile } = useWindowSize(), registeredModal = registeredModals.find((m) => m.elementId === elementId && !!m.node), targetRef = useCallback(
    (node) => {
      const shouldRegister = !!node && !registeredModal, shouldUnregister = windowIsMobile || !node && !!registeredModal, usedNode = windowIsMobile ? null : node;
      (shouldRegister || shouldUnregister) && setRegisteredModals(
        (prev) => prev.map((m) => m.elementId !== elementId ? m : { ...m, node: usedNode })
      );
    },
    [elementId, registeredModal, setRegisteredModals, windowIsMobile]
  ), isCurrentTarget = currentModal && currentModal.elementId === elementId;
  return {
    /**
     * Ref that is used for the target element to register/unregister it with the
     *   focus modal context
     */
    targetRef,
    targetZIndex,
    /** Element with matching `elementId` is the current focus modal target */
    isCurrentTarget
  };
}
export {
  useFocusModal
};
//# sourceMappingURL=useFocusModal.js.map
